import * as React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function MenuCard({ menuItems }) {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  const handleCardClick = (id) => {
    navigate(`/menu/${id}`);
  };

  const handleAddToCart = (event, item) => {
    event.stopPropagation();
    addToCart(item, 1);
    setSnackbarMessage(`${item.name} added to cart!`);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Grid container spacing={2}>
        {menuItems?.map((item, index) => {
          return (
            <Grid item xs={3} key={index}>
              <Card
                sx={{ maxWidth: 345 }}
                onClick={() => handleCardClick(item._id)}
              >
                <CardMedia
                  sx={{ height: 140 }}
                  image={item.image}
                  //image={`http://localhost:3001/${item.image}`}
                  title="menu-item"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {item.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                  <Typography variant="h4" color="text.secondary">
                    ₹{item.price}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={(event) => handleAddToCart(event, item)}
                    sx={{
                      ":hover": {
                        bgcolor: "primary.main",
                        color: "white",
                        border: "1px solid rgba(0, 0, 0, 0.23)",
                      },
                    }}
                  >
                    Add to cart
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
